// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"135":"group-auth","638":"group-admin"}[chunkId] + "." + {"135":"cd853edb","638":"9b87b0e4"}[chunkId] + ".js";
};